import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/assets/images/icons/icon-palette.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src405589514/src/apps/jumplab/src/features/gfWorks/components/MaterialContainer/MaterialContainer.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/features/gfWorks/components/WorksDetailFooterProductFirst/WorksDetailFooterProductFirst.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src405589514/src/apps/jumplab/src/features/gfWorks/components/WorksDetailThumbnail/WorksDetailThumbnail.tsx");
